import { render, staticRenderFns } from "./PreviewFiles.vue?vue&type=template&id=c6328570&scoped=true&"
import script from "./PreviewFiles.vue?vue&type=script&lang=js&"
export * from "./PreviewFiles.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFiles.vue?vue&type=style&index=0&id=c6328570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6328570",
  null
  
)

export default component.exports